import React from "react"
import { TitleContainer, Title, SmallText } from "./styles"
import { ScrollToSeeMore } from "components/ScrollToSeeMore"

const HeroTitle = ({ type = "scroll", smallTitle, bigTitle, timeline }) => {
  return (
    <>
      <TitleContainer className={timeline ? 'timeline' : ''}>
        <SmallText>{smallTitle ? smallTitle : "Beksiński"}</SmallText>
        <Title>{bigTitle}</Title>
      </TitleContainer>
      <ScrollToSeeMore type={type} />
    </>
  )
}
export { HeroTitle }
